/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Modals\ModalGroup\ModalGroup.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Thursday July 20th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday, 9th August 2023 03:35:59
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { Fragment, MouseEventHandler, useEffect, useState } from "react";
import MyModal from "Content/Modals/MyModal";
import {Form, Button, Col, InputGroup} from "react-bootstrap";
import translator from "MultiLanguage/TranslationWrapper";
import Styles from "Content/Modals/ModalCarPicture/ModalCarPicture.module.css";
import LoadingScreen from "Content/LoadingScreen/LoadingScreen";
import ModalConfirmation from "Content/Modals/ModalConfirmation/ModalConfirmation";
import CarService from "Services/Car/CarService";
import { AxiosResponse } from "axios";

type ModalProps = {
    show: boolean;
    onClose: MouseEventHandler<HTMLDivElement>;
    closeModal: MouseEventHandler;
    title: string,
    name: string,
    carID: string,
    carIdx: number,
};

function ModalCarPicture(props: ModalProps) {
    const [name, setName] = useState(props.name);
    const [file, setFile] = useState<File[] | undefined>();
    const [isSendable, setIsSendable] = useState(false);
    const [spinner, setSpinner] = useState(false);
    const [isOkay, setIsOkay] = useState<boolean>(false);
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [additionnalMessage, setAdditionnalMessage] = useState("");

    useEffect(() => {
        setName(props.name);
    }, [props.name]);

    const setModalConfig = (isSendable=false, isOkay=false, open: boolean) => {
        setIsSendable(isSendable);
        setIsOkay(isOkay);
        setOpenModal(open);
    };

    const HandleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (!file)
            return;
        setSpinner(true);

        const promises: Promise<AxiosResponse<any, any>>[] = [];
        for (let i = 0; i < file.length; ++i) {
            const picName = `${name}-pic-${props.carIdx + i}`;
            promises.push(CarService.createCarPicture(props.carID, picName, props.carIdx + i, file[i]));
        }
        Promise.all(promises).then(result => {
            if (result) {
                setFile(undefined);
                setModalConfig(false, true, true);
                setOpenModal(true);
            } else
                throw "";
        }).catch((error) => {
            setAdditionnalMessage(error.message);
            setFile(undefined);
            setModalConfig(false, false, true);
        });

        setSpinner(false);
    };

    useEffect(() => {
        if (name && file)
            setIsSendable(true);
        else
            setIsSendable(false);
    }, [name, file]);

    function setFromFile(e: any) {
        setFile(e.target.files);
    };

    return(
        <Fragment>
            <MyModal closeModal={props.closeModal} show={props.show} addCloseCross={true} onClose={props.onClose} footer={(() => { return (<></>); })()} title={props.title} className={Styles.modal}>
                <Form className={`${Styles.formHolder}`} onSubmit={HandleSubmit}>
                    <Form.Group className={`${Styles.formfield}`} >
                        <Col>
                            <Form.Label>
                                {translator.decode("dynamic.name")}
                            </Form.Label>
                            <Form.Control type="text" value={name} onChange={(e) => setName(e.target.value)} />
                            <Form.Label>
                                {translator.decode("visuals.modal.file")}
                            </Form.Label>
                            <InputGroup>
                                <Form.Control type="file" accept=".png,.jpg,.jpeg,.webp" multiple placeholder={translator.decode("visuals.modal.pickfile")} onChange={setFromFile} />
                            </InputGroup>
                        </Col>
                    </Form.Group>
                    <Button disabled={!isSendable} className="mb-3" type="submit">{translator.decode("dynamic.create")}</Button>
                </Form>
                {
                    spinner ?
                        <div className={`${Styles.spinnerHolder}`}>
                            <LoadingScreen />
                        </div>
                        :null
                }
            </MyModal>
            <ModalConfirmation show={openModal} onClose={() => setOpenModal(false)} closeModal={() => setOpenModal(false)} isOkay={isOkay} additionnalMessage={additionnalMessage} />
        </Fragment>
    )
}

export default ModalCarPicture;
